import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import {
  IAdminReportRO,
  IAdminReportRoStatusEnum,
  IAdminReportRoTypeEnum,
  IAdminReportUpdateStatusEnum,
} from 'api'
import parse from 'html-react-parser'
import { useNavigate } from 'react-router-dom'

export default function ReportDetail() {
  const id = useQueryValue('id', 0)
  const navigate = useNavigate()
  const { data } = useApi({
    id: 'reportDetail',
    fn: api().adminReport.getReportDetail,
    params: id,
    enabled: !!id,
  })

  const onSave = async (data: IAdminReportRO) => {
    await api().adminReport.updateReport(id, {
      status: data.status as unknown as IAdminReportUpdateStatusEnum,
    })

    navigate('/report')
  }

  console.log(data)

  return (
    <ContentDetailView data={data} title="신고 수정" onSave={onSave}>
      <DetailForm
        data={data}
        fields={[
          {
            type: FormFieldType.STRING,
            key: 'user.email',
            label: '신고계정',
            readOnly: true,
          },
          {
            type: FormFieldType.STRING,
            key: 'reason',
            label: '신고사유',
            readOnly: true,
          },
          {
            type: FormFieldType.CUSTOM_READ_ONLY,
            key: 'description',
            label: '신고 내용',
            readOnly: true,
            render(data) {
              return (
                <div className="max-h-[150px] min-h-[150px] overflow-y-scroll">
                  {parse(data?.description || '')}
                </div>
              )
            },
          },
          {
            type: FormFieldType.STRING,
            key: 'targetData.type',
            label: '게시판',
            readOnly: true,
            resolver: (v) => {
              const type = v.targetData.type as IAdminReportRoTypeEnum
              return type === IAdminReportRoTypeEnum.CommunityArticle
                ? '커뮤니티'
                : type === IAdminReportRoTypeEnum.ClinicReview
                  ? '병원후기'
                  : '신규장비'
            },
          },
          {
            type: FormFieldType.STRING,
            key: 'targetData.title',
            label: '게시글 제목',
            readOnly: true,
          },
          {
            type: FormFieldType.CUSTOM_READ_ONLY,
            key: 'targetData.content',
            label: '게시글 내용',
            readOnly: true,
            render(data) {
              return (
                <div className="max-h-[150px] min-h-[150px] overflow-y-scroll">
                  {parse(data?.targetData?.content || '')}
                </div>
              )
            },
          },
          {
            type: FormFieldType.CUSTOM_READ_ONLY,
            label: '신고 게시글 URL',
            key: 'targetData',
            render(data) {
              return (
                <a href={data?.targetUrl || ''} target="_blank">
                  {data?.targetUrl || ''}
                </a>
              )
            },
          },
          {
            type: FormFieldType.SELECT,
            key: 'status',
            label: '상태',
            options: [
              {
                value: IAdminReportRoStatusEnum.PENDING,
                label: '대기중',
              },
              {
                value: IAdminReportRoStatusEnum.PROCESSING,
                label: '처리중',
              },
              {
                value: IAdminReportRoStatusEnum.COMPLETED,
                label: '처리완료',
              },
            ],
          },
        ]}
      />
    </ContentDetailView>
  )
}
